import { render } from "./ShopFavorites.vue?vue&type=template&id=15167212&scoped=true"
import script from "./ShopFavorites.vue?vue&type=script&lang=js"
export * from "./ShopFavorites.vue?vue&type=script&lang=js"

import "./ShopFavorites.vue?vue&type=style&index=0&id=15167212&scoped=true&lang=css"
import "./ShopFavorites.vue?vue&type=style&index=1&id=15167212&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15167212"]])

export default __exports__